<app-page-header
  [header]="'information-about-journey.' + (isAppTravelAgency ? 'travel-agency-title': 'title') + '.tripAbroad'" />

<app-coverage-information></app-coverage-information>

<qbe-panel-component>
  <app-form-element header="information-about-journey.destination.title">
    <app-dynamic-input
      [formGroup]="formGroup"
      name="destination"
      inputType="groupedSelect"
      label="information-about-journey.destination.label"
      placeholder="information-about-journey.destination.placeholder"
      [groupedOptions]="(countriesOptions$ | async) ?? []"
    ></app-dynamic-input>
    <nx-message *ngIf="countryAdditionalInfo$ | async" class="u-mt-md" context="info">
      <b>{{ (countryAdditionalInfo$ | async) || '' | translate }}</b>
    </nx-message>
  </app-form-element>
  <app-form-element header="information-about-journey.travelDates.title">
    <app-dynamic-input
      [formGroup]="formGroup.controls.travelDates"
      name="dateFrom"
      inputType="date"
      label="information-about-journey.travelDates.dateFrom.label"
      [minDate]="minDate"
      [maxDate]="maxDate(null, today)"
    ></app-dynamic-input>
    <app-dynamic-input
      [formGroup]="formGroup.controls.travelDates"
      name="dateTo"
      inputType="date"
      label="information-about-journey.travelDates.dateTo.label"
      [minDate]="formGroup.controls.travelDates.controls.dateFrom.value || undefined"
      [maxDate]="maxDate(formGroup.controls.travelDates.controls.annual.value, formGroup.controls.travelDates.controls.dateFrom.value)"
    ></app-dynamic-input>
    <app-dynamic-input
      [formGroup]="formGroup.controls.travelDates"
      name="annual"
      inputType="checkbox"
      label="information-about-journey.travelDates.annual.label"
      class="nx-margin-top-s"
    ></app-dynamic-input>
    <nx-message *ngIf="formGroup.controls.travelDates.controls.annual.value === true" class="u-mt-md" context="info">
      <b>{{ 'information-about-journey.travelDates.annual.additionalInfo.title' | translate }}</b
      ><br />
      {{ 'information-about-journey.travelDates.annual.additionalInfo.description' | translate }}

      <button nxPlainButton class="nx-margin-top-s" (click)="modalService.openModal(modalType.LeisureSports)" type="button">
        <div class="button-icon-left">
          <nx-icon name="file-text"></nx-icon>
          {{ 'information-about-journey.leisureSports.modalButton' | translate }}
        </div>
      </button>
    </nx-message>
    <nx-message *ngIf="isTodaySelected(formGroup.controls.travelDates.controls.dateFrom.value)" class="u-mt-md" context="info">
      {{ 'information-about-journey.travelDates.dateFrom.additionalInfo.description' | translate }}
    </nx-message>
  </app-form-element>
  <app-form-element
    *ngIf="isPolandIsCurrentResidingVisible$ | async"
    [header]="
      formGroup.controls.travelDates.controls.annual.value === true
        ? 'information-about-journey.isPolandIsCurrentResiding.annualTitle'
        : 'information-about-journey.isPolandIsCurrentResiding.title'
    "
  >
    <app-dynamic-input
      [formGroup]="formGroup"
      name="isPolandIsCurrentResiding"
      inputType="yesNo"
      label="information-about-journey.isPolandIsCurrentResiding.label"
    ></app-dynamic-input>
    <nx-message *ngIf="formGroup.controls.isPolandIsCurrentResiding.value === false" context="info" class="nx-margin-top-m">
      <b>{{
        'information-about-journey.isPolandIsCurrentResiding.additionalInfo.description' | translate : isPolandIsCurrentResidingParams
      }}</b>
    </nx-message>
  </app-form-element>
  <app-form-element
    *ngIf="formGroup.controls.travelDates.controls.annual.value === true"
    header="information-about-journey.with60DaysReturns.title"
  >
    <app-dynamic-input
      [formGroup]="formGroup.controls.travelDates"
      name="with60DaysReturns"
      inputType="yesNo"
      label="information-about-journey.with60DaysReturns.label"
    ></app-dynamic-input>
  </app-form-element>
  <app-form-element *ngIf="!formGroup.controls.travelDates.controls.annual.value" header="information-about-journey.numberOfInsureds.title">
    <ng-container description *ngIf="isAppAgentOrTravelAgency">
      <button nxPlainButton (click)="modalService.openModal(modalType.InsuredImport)" type="button">
        {{ 'information-about-journey.numberOfInsureds.importButton' | translate }}
      </button>
    </ng-container>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="numberOfInsureds"
      inputType="numberStepper"
      label="information-about-journey.numberOfInsureds.label"
    ></app-dynamic-input>
  </app-form-element>
  <app-form-element header="information-about-journey.insuredBirthYear.title">
    <app-dynamic-input-array
      [formGroup]="formGroup"
      name="insuredBirthYear"
      inputType="year"
      label="information-about-journey.insuredBirthYear.label"
    ></app-dynamic-input-array>
  </app-form-element>
  <app-form-element
    *ngIf="formGroup.controls.travelDates.controls.annual.value !== true"
    header="information-about-journey.winterSportsHiRisk.title"
  >
    <ng-container *ngIf="!isAppAgentOrTravelAgency" description>
      <p nxCopytext="normal">
        {{ 'information-about-journey.winterSportsHiRisk.description.text' | translate }}
        <button
          nxPlainButton
          type="button"
          class="nx-font-weight-bold"
          (click)="modalService.openModal(modalType.ContactAgent, { data: { type: 'winterSportsHiRisk' } })"
        >
          {{ 'information-about-journey.winterSportsHiRisk.description.button' | translate }}
        </button>
      </p>
    </ng-container>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="winterSportsHiRisk"
      class="u-mb-dynamic"
      inputType="yesNo"
      label="information-about-journey.winterSportsHiRisk.label"
    ></app-dynamic-input>
    <button nxPlainButton (click)="modalService.openModal(modalType.HighRisk)" type="button">
      <div class="button-icon-left">
        <nx-icon name="file-text" class="nx-margin-right-2xs"></nx-icon>
        {{ 'information-about-journey.winterSportsHiRisk.modalButton' | translate }}
      </div>
    </button>
  </app-form-element>
  <app-form-element
    *ngIf="formGroup.value.winterSportsHiRisk && (formGroup.value.numberOfInsureds || 0) > 1"
    header="information-about-journey.allHighRisk.title"
  >
    <app-dynamic-input
      [formGroup]="formGroup"
      name="winterSportsHiRiskForAllInsureds"
      class="u-mb-dynamic"
      inputType="yesNo"
      label="information-about-journey.allHighRisk.label"
      [yesNoValues]="hiRiskValues"
    ></app-dynamic-input>
    <div *ngIf="formGroup.controls.winterSportsHiRiskForAllInsureds.value === false" class="azt-subform">
      <h3 nxHeadline="subsection-small" class="azt-subform-headline">
        {{ 'information-about-journey.personsWithWinterSportsHiRisk.description.text' | translate }}
      </h3>
      <div class="azt-subform-content">
        <app-dynamic-input-array
          [formGroup]="formGroup"
          name="personsWithWinterSportsHiRisk"
          inputType="checkbox"
          label="information-about-journey.personsWithWinterSportsHiRisk.label"
          [labelArgs]="personsWithLabelArgs"
        ></app-dynamic-input-array>
        <nx-error
          *ngIf="formGroup.controls.personsWithWinterSportsHiRisk.touched && formGroup.hasError('noPersonWithWinterSportsHiRisk')"
          class="nx-margin-top-xs"
        >
          {{ 'forms.validator.noPersonWithWinterSportsHiRisk' | translate }}
        </nx-error>
      </div>
    </div>
  </app-form-element>
  <app-form-element
    *ngIf="isAppAgentOrTravelAgency && formGroup.controls.travelDates.controls.annual.value !== true"
    header="information-about-journey.withExtremeSports.title"
  >
    <ng-container description>
      <p nxCopytext="normal">
        {{ 'information-about-journey.withExtremeSports.description' | translate }}
      </p>
    </ng-container>
    <app-dynamic-input [formGroup]="formGroup" name="withExtremeSports" class="u-mb-dynamic" inputType="yesNo"></app-dynamic-input>
  </app-form-element>
  <app-form-element
    *ngIf="isAppAgentOrTravelAgency && formGroup.controls.withExtremeSports.value && (formGroup.value.numberOfInsureds || 0) > 1"
    header="information-about-journey.extremeSportsForAllInsureds.title"
  >
    <app-dynamic-input
      [formGroup]="formGroup"
      name="extremeSportsForAllInsureds"
      class="u-mb-dynamic"
      inputType="yesNo"
      [yesNoValues]="competitiveSportsValues"
    ></app-dynamic-input>
    <div *ngIf="formGroup.controls.extremeSportsForAllInsureds.value === false" class="azt-subform">
      <h3 nxHeadline="subsection-small" class="azt-subform-headline">
        {{ 'information-about-journey.personsWithExtremeSports.description.text' | translate }}
      </h3>
      <div class="azt-subform-content">
        <app-dynamic-input-array
          [formGroup]="formGroup"
          name="personsWithExtremeSports"
          inputType="checkbox"
          label="information-about-journey.personsWithExtremeSports.label"
          [labelArgs]="personsWithLabelArgs"
        ></app-dynamic-input-array>
      </div>
    </div>
  </app-form-element>
  <app-form-element *ngIf="!isAppAgentOrTravelAgency" header="information-about-journey.phoneNumber.title" [last]="true">
    <ng-container description>
      <p nxCopytext="normal">
        {{ 'information-about-journey.phoneNumber.description.text1' | translate }}
      </p>
      <p nxCopytext="normal">
        {{ 'information-about-journey.phoneNumber.description.text2' | translate }}
      </p>
    </ng-container>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="phoneNumber"
      inputType="phoneNumber"
      label="information-about-journey.phoneNumber.label"
    ></app-dynamic-input>
  </app-form-element>
</qbe-panel-component>
